import {
  GridViewIcon,
  LockIcon,
  StarIcon,
  Tick02Icon
} from '@hugeicons/react'
import { FireIcon } from '@hugeicons/react'
import type { ReactNode } from 'react'

import type { FilterChipOption } from '@/shared/ui/Layout/page/FilterChips'

import { QUIZ_FILTERS, type QuizFilterId } from '../constants/status'

const QUIZ_FILTER_ICONS: Partial<Record<QuizFilterId, ReactNode>> = {
  all: <GridViewIcon size={12} variant="stroke" aria-hidden />,
  available: (
    <StarIcon size={12} variant="duotone" style={{ color: 'var(--color-brand)' }} aria-hidden />
  ),
  progress: (
    <FireIcon size={12} variant="stroke" style={{ color: '#ff9800' }} aria-hidden />
  ),
  success: (
    <Tick02Icon size={12} variant="stroke" style={{ color: '#22c55e' }} aria-hidden />
  ),
  locked: (
    <LockIcon size={12} variant="stroke" style={{ color: '#a1a5b7' }} aria-hidden />
  )
}

export const QUIZ_FILTER_OPTIONS: FilterChipOption<QuizFilterId>[] =
  QUIZ_FILTERS.map(filter => ({
    ...filter,
    icon: QUIZ_FILTER_ICONS[filter.id]
  }))
